import { useDroppable } from '@dnd-kit/core';
import cn from 'classnames';
import { FC, ReactNode } from 'react';

type DropZonePlaceholderProps = {
  id: string;
  isActive: boolean;
  className?: string;
  activeClassName?: string;
  children?: ReactNode;
};

export const DropZonePlaceholder: FC<DropZonePlaceholderProps> = (props) => {
  const { id, isActive, className, activeClassName, children } = props;

  const { setNodeRef } = useDroppable({ id });

  return (
    <div
      ref={setNodeRef}
      data-component="template-drop-zone-placeholder"
      className={cn(className, isActive && activeClassName)}
    >
      {children}
    </div>
  );
};
